<template>
  <div>
    <logged-in-header />
    <courses-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import coursesPanel from "../components/courses/CoursesPanel";

export default {
  components: {
    loggedInHeader,
    coursesPanel
  }
};
</script>
